import { autoinject, bindingMode } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/essette-api';
import { HouseholdService } from 'app/cd/services/household-service';
import { Toaster } from 'app/shared/lib/toaster';
import { validate } from 'app/shared/elements/ess-rule';
import { I18N } from 'aurelia-i18n';
import { deepClone } from 'app/shared/lib/utilities';
import * as CD from 'app/cd/models/essette-api';


@autoinject()
export class SaveHousehold extends ComponentBase implements IForm {

    ////****************** Fields and Properties ************************************////
    @bindable.boolean({ defaultBindingMode: bindingMode.twoWay })
    protected createHouseholdOpen: boolean = false;

    @bindable.object({ defaultBindingMode: bindingMode.twoWay })
    protected household: CD.Household = {};

    protected editedHousehold?: CD.Household;

    protected validate = validate;
    protected isValid: boolean = false;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: HouseholdService,
        private readonly toaster: Toaster,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }


    ////****************** Events ***************************************************////
    protected householdChanged(): void {
        this.editedHousehold = this.household.id ? deepClone(this.household) : {};
    }

    ////****************** Functions ************************************************////
    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public reset(): void {
        this.createHouseholdOpen = false;
        this.household = {};
    }

    public async submit(): Promise<boolean> {
        return await this.saveHousehold();
    }


    ////****************** Service Calls ********************************************////
    @apiCall
    protected async saveHousehold(): Promise<boolean> {
        if(!this.editedHousehold) return false;

        let isSuccessful = false;
        try {
            this.state.beginSave();

            const response = await this.service.saveHousehold(this.editedHousehold);
            isSuccessful = response.isSuccessful;

            // if creating a new household, save its new ID to the shared household object
            if(response.id && !this.household.id) this.household.id = response.id;

            // and update the shared household object with any other changes
            this.household.description = this.editedHousehold.description;
            this.household.identifier = {
                ...this.household.identifier,
                primary: this.editedHousehold.identifier?.primary
            }
            return response.isSuccessful;
        } catch(error) {
            // if duplicate constraint violated on primary identifier, show toast
            if(error.status.errors) {
                const invalidId = error.status.errors.some((err: any) => err.code === 'property.constraintViolated' && err.property === 'identifier.primary');
                if(invalidId) this.toaster.error().message(this.i18n.tr('ui:messages.warnings.inUse', { what: this.i18n.tr('cd:household.identifier.$long') })).show();
            }
            throw error;
        } finally {
            this.toaster.standard.saved('cd:household.$', isSuccessful);
            this.state.endSave();
        }
    }
}
